export const redirectTo = (url: string, location = window.location) => {
    location.replace(url);
};

export const getMessageFromUrl = (url: string, t: (value: string) => string): string => {
    const patterns = [
        {
            regex: /^\/compare\/\d+\/[a-f0-9-]+$/i,
            message: t('compareReportView'),
        },
        {
            regex: /^\/view\/\d+$/,
            message: t('reportView'),
        },
        {
            regex: /^\/$/,
            message: t('listOfReturnsView'),
        },
        {
            regex: /^\/view\/\d+\/forms\/[a-f0-9-]+\/[a-z0-9]+$/i,
            message: t('formView'),
        },
    ];

    const match = patterns.find((pattern) => pattern.regex.test(url));

    return match ? match.message : '';
};
